import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { ensurePermissions } from '@/hooks/usePermissions';

export const Route = createFileRoute('/(client)/report/(pages)')({
  beforeLoad: async () => {
    const perms = await ensurePermissions();
    if (!perms.reports.canRead) {
      throw redirect({ to: '/dashboard' });
    }
  },
  component: () => <Outlet />,
});
